import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
// import { ImageComponent } from 'react-bootstrap';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Dropdown, Form } from "react-bootstrap";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Paper from "@material-ui/core/Paper";
import "../css/companyTable.css";
import firebase from "firebase";
import "firebase/database";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import "bootstrap/dist/css/bootstrap.min.css";
import { store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import ReactNotification from "react-notifications-component";
import "animate.css/animate.min.css";
import { FormControlLabel, TableSortLabel } from "@material-ui/core";
import PropTypes from "prop-types";
import SearchBar from "material-ui-search-bar";
import { getLogoURL } from "../App";
// import { Alert } from "@coreui/react";
// import { LazyLoadImage } from "react-lazy-load-image-component";
// import { ref, set } from "firebase/database";

const useStyles = (theme) => ({
  table: {
    marginTop: theme.spacing(3),
    "& thead th": {
      fontWeight: "600",
      color: theme.palette.primary.main,
      // backgroundColor: theme.palette.primary.light,
    },
    "& tbody td": {
      fontWeight: "300",
    },
    "& tbody tr:hover": {
      backgroundColor: "#fffbf2",
      cursor: "pointer",
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
});

// const styles = useStyles();

class CompanyTable extends Component {
  constructor() {
    super();

    this.jobCategories = {
      swe: "Software Engineering",
      ds: "Data Science",
      pm: "Product Manager",
      qr: "Quant",
      ml: "Machine Learning",
      ba: "Business Analytics",
      other: "Other",
    };

    this.invJobCategories = {
      "Software Engineering": "swe",
      "Data Science": "ds",
      "Product Manager": "pm",
      Quant: "qr",
      "Machine Learning": "ml",
      "Business Analytics": "ba",
      Other: "other",
    };

    this.state = {
      headCells: [
        { displayName: "Company", id: "company" },
        // { displayName: "Recruiting Status", id: "status" },
        { displayName: "Applicants", id: "num-applicants" },
        { displayName: "OA receivers", id: "num-first" },
        { displayName: "1st interview receivers", id: "num-second" },
        { displayName: "2nd interview receivers", id: "num-third" },
        { displayName: "3rd interview receivers", id: "num-fourth" },
        { displayName: "Num Offered", id: "num-offered" },
        { displayName: "Num Rejected", id: "num-rejected" },
      ],
      displayCategory: this.jobCategories["swe"],
      order: undefined,
      companies: {},
      orderBy: "",
      filter: "",
      filterFn: {
        fn: (items) => {
          return items;
        },
      },
    };
  }

  handleClick(e, companyName) {
    // this.props.history.push("/"+companyName.replace(/\s/g), {from: companyName});
    // this.props.history.push("/company/" + companyName.replace(/ /g, "_"));
    this.props.history.push(
      "/company/" +
        companyName.replace(/ /g, "_") +
        "/" +
        this.invJobCategories[this.state.displayCategory]
    );
  }

  async getFBData() {
    console.log(this.state.displayCategory);
    const companyInfo = [];
    const companyDocuments = await firebase
      .firestore()
      .collection(this.invJobCategories[this.state.displayCategory])
      .where("isPublic", "==", true)
      .get();
    companyDocuments.forEach((company) => {
      const companyData = company.data();
      // companyNames.push(companyData.name);
      companyData["url"] = getLogoURL(companyData.name);
      companyData["id"] = company.id;
      companyInfo.push(companyData);
    });
    console.log(companyInfo);
    this.setState({
      // companyNames: companyNames,
      // urlsReveived: true,
      companies: companyInfo,
    });
  }

  componentDidMount() {
    this.getFBData();
  }

  handleFilterChange(newVal) {
    console.log(newVal);
    this.setState({
      filterFn: {
        fn: (items) => {
          if (newVal == "") return items;
          else
            return items.filter((x) =>
              this.state.companies[x].name.toLowerCase().includes(newVal)
            );
        },
      },
      filter: newVal,
    });
    // this.setState({ filter: newVal });
  }

  render() {
    const classes = {
      table: {
        minWidth: 650,
      },
    };

    return (
      <React.Fragment>
        <div className="container m-auto">
          {/* <TableContainer component={Paper} className="table"> */}
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-6 mb-2 col-lg-3">
              <Dropdown className=" " style={{ alignSelf: "center" }}>
                <Dropdown.Toggle
                  style={{ alignSelf: "center" }}
                  className="mx-auto"
                  variant="primary"
                  id="dropdown-basic"
                >
                  {this.state.displayCategory}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {Object.keys(this.invJobCategories).map((cat) => {
                    return (
                      <Dropdown.Item
                        key={cat}
                        onClick={(e) => {
                          this.setState({ displayCategory: cat }, () => {
                            this.getFBData();
                          });
                        }}
                        active={cat == this.state.displayCategory}
                      >
                        {cat}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <SearchBar
              className="col-12 col-lg-6"
              value={this.state.filter}
              placeholder="Search Companies"
              onChange={(newValue) => this.handleFilterChange(newValue)}
              onRequestSearch={() => console.log("submit")}
            />
          </div>
          <div className="row">
            <Table
              style={classes.table}
              className="col-12 mt-3"
              aria-label="simple table"
            >
              <TableHead
                style={{
                  backgroundColor: "red !important",
                }}
              >
                <TableRow className="colNames">
                  {this.state.headCells.map((obj) => (
                    <TableCell
                      className="colName"
                      align="left"
                      // align={obj.align}
                      // style={obj.style}
                      sortDirection={
                        this.state.orderBy === obj.id ? this.state.order : false
                      }
                    >
                      {obj.disableSorting ? (
                        obj.displayName
                      ) : (
                        <TableSortLabel
                          active={this.state.orderBy === obj.id}
                          direction={
                            this.state.orderBy === obj.id
                              ? this.state.order
                              : "asc"
                          }
                          onClick={() => {
                            this.handleSortRequest(obj.id);
                          }}
                        >
                          {obj.displayName}
                        </TableSortLabel>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.recordsAfterPagingAndSorting().map((key) => (
                  <TableRow
                    key={key}
                    onClick={(event) =>
                      this.handleClick(event, this.state.companies[key].id)
                    }
                  >
                    <TableCell component="th" scope="row">
                      <div
                        className="media company-info-cell"
                        style={{ alignItems: "center" }}
                      >
                        <div className="mr-0 py-2 py-sm-0 mr-md-4 ml-0 ml-xl-1">
                          <div
                            className="bg-white"
                            style={{ alignItems: "center" }}
                          >
                            <img
                              className="align-self-center"
                              loading="lazy"
                              src={this.state.companies[key].url}
                              key={key}
                              width="45px"
                              // style={{ width: "30px" }}
                              // onerror={{"this.onerror=null;this.src='https://i.imgur.com/nwWg68V.png';this.width='25';"}}
                            />
                          </div>
                        </div>
                        <div className="media-body align-self-center">
                          <h5
                            style={{ cursor: "pointer" }}
                            className="font-weight-bold"
                          >
                            {this.state.companies[key].name}{" "}
                            {/* <span className="ml-1">
                          <i className="fal fa-long-arrow-right"></i>
                        </span> */}
                          </h5>
                          {/* <p className="text-muted small mt-0 mb-0">
                        New York, NY - Fall 2021
                      </p> */}
                        </div>
                      </div>

                      {/* {this.state.companies[key].name} */}
                    </TableCell>
                    {/* <TableCell component="th" scope="row">
                    {this.state.companies[key].name}
                  </TableCell> */}
                    {/* <TableCell align="left">
                      <div
                        style={{
                          color: "#007329 !important",
                          backgroundColor: "#88e8b3 !important",
                          padding: "5px 8px",
                          borderRadius: "5px",
                          fontSize: "12px",
                        }}
                      >
                        {this.state.companies[key].recruitingStatus}
                      </div>
                    </TableCell> */}
                    <TableCell align="left">
                      {this.state.companies[key].numApplied}
                    </TableCell>
                    <TableCell align="left">
                      {this.state.companies[key].numFirst}
                      {/* {this.state.companies[key].interviews >= 1
                        ? this.state.companies[key].numFirst
                        : "n/a"} */}
                    </TableCell>
                    <TableCell align="left">
                      {this.state.companies[key].numSecond}
                      {/* {this.state.companies[key].interviews >= 2
                        ? this.state.companies[key].numSecond
                        : "n/a"} */}
                    </TableCell>
                    <TableCell align="left">
                      {this.state.companies[key].numThird}
                      {/* {this.state.companies[key].interviews >= 3
                        ? this.state.companies[key].numThird
                        : "n/a"} */}
                    </TableCell>
                    <TableCell align="left">
                      {this.state.companies[key].numFourth}
                      {/* {this.state.companies[key].interviews >= 4
                        ? this.state.companies[key].numFourth
                        : "n/a"} */}
                    </TableCell>
                    <TableCell align="left">
                      {this.state.companies[key].numOffered}
                    </TableCell>
                    <TableCell align="left">
                      {this.state.companies[key].numRejected}
                    </TableCell>
                    {/* <TableCell align="left">Trend Preview</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          {/* </TableContainer> */}
          {/* <ReactNotification /> */}
        </div>
      </React.Fragment>
    );
  }

  handleSortRequest(columnId) {
    const isAsc = this.state.orderBy === columnId && this.state.order === "asc";
    this.setState({ order: isAsc ? "desc" : "asc", orderBy: columnId });
    // setOrderBy(columnId);
  }

  // handleRowsPerPageChange(event) {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  // }

  // handlePageChange(event, newPage) {
  //   setPage(newPage);
  // }

  stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    console.log(stabilizedThis.map((el) => el[0]));
    return stabilizedThis.map((el) => el[0]);
  }

  getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy);
  }

  descendingComparator(a, b, orderBy) {
    if (orderBy === "name") {
      if (
        this.state.companies[b].name.localeCompare(
          this.state.companies[a].name
        ) < 0
      )
        return -1;
      if (
        this.state.companies[b].name.localeCompare(
          this.state.companies[a].name
        ) > 0
      )
        return 1;
    } else if (orderBy == "status") {
      if (
        this.state.companies[b].recruitingStatus.localeCompare(
          this.state.companies[a].recruitingStatus
        ) < 0
      )
        return -1;
      if (
        this.state.companies[b].recruitingStatus.localeCompare(
          this.state.companies[a].recruitingStatus
        ) > 0
      )
        return 1;
    }
    // if(b[orderBy] < a[orderBy]) return -1;
    // if(b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  recordsAfterPagingAndSorting() {
    console.log("hi");
    console.log(this.state.filterFn.fn(Object.keys(this.state.companies)));
    return this.stableSort(
      this.state.filterFn.fn(Object.keys(this.state.companies)),
      this.getComparator(this.state.order, this.state.orderBy)
    ); //.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  }
}

CompanyTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(withRouter(CompanyTable));
// export default CompanyTable;
